module.exports = __webpack_public_path__ + "img/residenziale_idle.13ece576.png";